export interface Category {
  id: string;
  name: string;
  icon: string;
  color: string;
  background: string;
  description: string;
  coreArea?: CORE;
}

export interface IQuestion {
  id: string;
  translations: {
    language: LANGUAGE_TRANSLATION | string;
    text: string;
  }[];
  createdAt: Date | string;
  answerMode: ANSWER_TYPE;
  categories: Category[];
  type: QUESTION_TYPE;
  actor?: QUESTION_ACTOR;
  self?: boolean;
  column?:string;
  enabled: boolean;
  isIssueLinked: boolean;
  templates: string[];
}
export interface QuestionPayload {
  translations: {
    language: LANGUAGE_TRANSLATION | string;
    text: string;
  }[];
  answerMode?: ANSWER_TYPE;
  categoryIds?: string[];
  type?: QUESTION_TYPE;
  actor?: QUESTION_ACTOR;
  self?: boolean;
}
export enum QUESTION_TYPE {
  CUSTOM = "CUSTOM",
  STANDARD = "STANDARD",
}

export enum QUESTION_ACTOR {
  HR = "HR",
  MANAGER = "MANAGER",
}

export enum CORE {
  C = "culture",
  O = "organization",
  R = "regulation",
  E = "economy",
}

export enum LANGUAGE_TRANSLATION {
  ITALIAN = "ITALIAN",
  ENGLISH = "ENGLISH",
  SPANISH = "SPANISH",
  GERMAN = "GERMAN",
  FRENCH = "FRENCH",
}

export enum LIST_CATEGORY {
  PERFORMANCE = "Performance",
  REMOTE_EFFICIENCY = "Remote Efficiency",
  MANAGER_INTERACTION = "Manager Interaction",
  PEERS_INTERACTION = "Peers Interaction",
}
export enum LIST_CATEGORY_FILTERS {
  ALL = "ALL",
  PERFORMANCE = "Performance",
  REMOTE_EFFICIENCY = "Remote Efficiency",
  MANAGER_INTERACTION = "Manager Interaction",
  PEERS_INTERACTION = "Peers Interaction",
}

export enum ANSWER_TYPE {
  LIKERT = "LIKERT",
  FREE_TEXT = "FREE_TEXT",
  DAYS = "DAYS",
}
export enum iconANSWER_TYPE {
  "icon-star" = "LIKERT",
  "icon-file" = "FREE_TEXT",
  "icon-planner" = "DAYS",
}
export const translations: { [key: string]: string }[] = Object.keys(
  LANGUAGE_TRANSLATION
).map((key) => ({
  [key]: LANGUAGE_TRANSLATION[key as keyof typeof LANGUAGE_TRANSLATION],
}));

export const category: { [key: string]: string }[] = Object.keys(
  LIST_CATEGORY
).map((key) => ({
  [key]: LIST_CATEGORY[key as keyof typeof LIST_CATEGORY],
}));
export const categoryFilter: { [key: string]: string }[] = Object.keys(
  LIST_CATEGORY_FILTERS
).map((key) => ({
  [key]: LIST_CATEGORY_FILTERS[key as keyof typeof LIST_CATEGORY],
}));

export const answerType: { [key: string]: string }[] = Object.keys(
  ANSWER_TYPE
).map((key) => ({
  [key]: ANSWER_TYPE[key as keyof typeof ANSWER_TYPE],
}));
export const answerTypeIcon: { [key: string]: string }[] = Object.keys(
  iconANSWER_TYPE
).map((key) => ({
  [key]: iconANSWER_TYPE[key as keyof typeof iconANSWER_TYPE],
}));

export interface TemplatePayload {
  translations: {
    language?: LANGUAGE_TRANSLATION | string;
    name?: string;
    description?: string;
  }[];
  questions: IQuestion[];
  image: string;
}

export interface PopulatedTemplate {
  id: string;
  createdAt: Date,
  translations: {
    language: LANGUAGE_TRANSLATION | string;
    name: string;
    description: string;
  }[];
  questions: IQuestion[];
  image: string;
  status: "ACTIVE" | "DRAFT" | "ARCHIVED";
}

export interface ITranslation {
  language: LANGUAGE_TRANSLATION | string;
  name?: string;
  description?: string;
  text?: string;
  title?: string;
  link?: string;
}

export const initialQuestion: QuestionPayload = {
  translations: [
    {
      language: "",
      text: "",
    },
  ],
};
export const initialTemplate = {
  translations: [
    {
      language: "",
      name: "",
      description: "",
    },
  ],
};
